import classNames from 'classnames';
import type { HTMLProps } from 'react';

export interface MaterialIconsProps extends HTMLProps<HTMLSpanElement> {
  iconName: string;
  fill?: boolean;
  fontSize?: string;
  weight?: 100 | 200 | 300 | 400 | 500 | 600 | 700;
  grade?: -25 | 0 | 200;
  opticalSize?: 20 | 24 | 40 | 48;
}

/**
 * https://fonts.google.com/icons
 * @param param0 Props
 * @param param0.iconName Icon name
 * @param param0.fill `true` if filled icon
 * @param param0.className class name
 * @constructor
 */
export const MaterialIcons = ({
  iconName,
  fill,
  fontSize = '1rem',
  weight = 400,
  grade = 0,
  opticalSize = 20,
  className,
  ...props
}: MaterialIconsProps) => (
  <span
    {...props}
    className={classNames('material-symbols-outlined select-none cursor-default', className)}
    style={{
      fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' ${grade}, 'opsz' ${opticalSize}`,
      fontSize: `${fontSize}`,
    }}
  >
    {iconName}
  </span>
);
